import React, { useState, useEffect, useRef } from "react";

//import css
import "./Mid-Section-Pc.scss";

//import components
import InformationCardPc from "../../OverView/Pc-and-Large-Screens/Information-Card-Pc";
import TransactionsTable from "./Payments-Table";
import DropdownSelect from "../../../assets/reusableComponents/dropDownSelect";
import InvoicePendingTable from "./InvoicesPendingTable";
import HouseSelectionModal from "./HouseSelectionModal";
import PaymentModal from "../../PaymentModal";
import { ReactComponent as CalenderIcon } from "../../../assets/icons/custom-calender-icon.svg";

//redux imports
import { useSelector, useDispatch } from "react-redux";
import {
  fetchPayments,
  listInvoicesUnpaid,
} from "../../../../redux/slices/sliceActions";

const MidSectionPaymentsPc = () => {
  // redux methods
  const dispatch = useDispatch();
  const { tenants, properties, waterinvoices, unpaidinvoices, payments } =
    useSelector((state) => state.landlordslice);

  // Add state for calculated percentages
  const [cardPercentages, setCardPercentages] = useState({
    invoicesPaid: 0,
    invoicesPending: 0,
    approvedPayments: 0,
    awaitingApproval: 0,
  });

  // Function to calculate percentages based on data
  const calculatePercentages = () => {
    if (!unpaidinvoices || !payments) {
      return {
        invoicesPaid: 0,
        invoicesPending: 0,
        approvedPayments: 0,
        awaitingApproval: 0,
      };
    }

    // Calculate invoices paid vs pending
    const totalInvoices = unpaidinvoices.length;
    const fullyPaidInvoices = unpaidinvoices.filter(
      (invoice) => invoice.payment_status === "fully_paid",
    ).length;
    const pendingInvoices = unpaidinvoices.filter(
      (invoice) =>
        invoice.payment_status === "pending" ||
        invoice.payment_status === "partially-paid",
    ).length;

    const invoicesPaidPercentage =
      totalInvoices > 0
        ? Math.round((fullyPaidInvoices / totalInvoices) * 100)
        : 0;
    const invoicesPendingPercentage =
      totalInvoices > 0
        ? Math.round((pendingInvoices / totalInvoices) * 100)
        : 0;

    // Calculate payment approval status
    const totalPayments = payments.length;
    const approvedPayments = payments.filter(
      (payment) => payment.status === "completed",
    ).length;
    const pendingPayments = payments.filter(
      (payment) => payment.status === "pending",
    ).length;

    const approvedPaymentsPercentage =
      totalPayments > 0
        ? Math.round((approvedPayments / totalPayments) * 100)
        : 0;
    const awaitingApprovalPercentage =
      totalPayments > 0
        ? Math.round((pendingPayments / totalPayments) * 100)
        : 0;

    return {
      invoicesPaid: invoicesPaidPercentage,
      invoicesPending: invoicesPendingPercentage,
      approvedPayments: approvedPaymentsPercentage,
      awaitingApproval: awaitingApprovalPercentage,
    };
  };

  // Update percentages when data changes
  useEffect(() => {
    const newPercentages = calculatePercentages();
    setCardPercentages(newPercentages);
  }, [unpaidinvoices, payments]);

  useEffect(() => {
    console.log("tom unpaidinvoices", unpaidinvoices);
    console.log("err payments", payments);
    console.log("calculated percentages", cardPercentages);
  }, [unpaidinvoices, payments, cardPercentages]);

  useEffect(() => {
    if (properties.length > 0) {
      const propertyId = properties.find(
        (property) => property.name === selectedApartment,
      )?._id;

      if (propertyId) {
        console.log("propertyId", propertyId);
        dispatch(
          fetchPayments({
            propertyId,
          }),
        ).then((res) => {
          console.log("payments fetched", res);
        });

        //fetch unpaid invoices for currrent month and year
        const selectedMonth = new Date().getMonth() + 1;
        const selectedYear = new Date().getFullYear();
        dispatch(
          listInvoicesUnpaid({
            property_id: propertyId,
            selectedMonth,
            selectedYear,
          }),
        ).then((res) => {
          console.log("unpaid invoices", res);
        });
      }
    }
  }, [properties]);

  // apartment variables - initialize with empty string instead of properties[0]?.name
  const [apartmentChoices, setApartmentChoices] = useState([]);
  const [selectedApartment, setSelectedApartment] = useState("");

  //property id - initialize with first property's ID
  const [selectedApartmentId, setSelectedApartmentId] = useState(
    properties[0]?._id || null,
  );

  useEffect(() => {
    console.log("properties", properties);
    if (Object.keys(properties).length > 0) {
      setApartmentChoices([...properties.map((property) => property.name)]);
      // Set selectedApartmentId to the first property's ID
      setSelectedApartmentId(properties[0]._id);
      // Set selectedApartment to the first property's name if not already set
      if (!selectedApartment) {
        setSelectedApartment(properties[0].name);
      }
    }
  }, [properties]);

  const [tableToView, setTableToView] = useState("transactions");

  //Navigation variables
  const [hovered, setHovered] = useState(false);
  const [hoveredSecond, setHoveredSecond] = useState(false);

  // Add state for modals
  const [showHouseSelectionModal, setShowHouseSelectionModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedHouseData, setSelectedHouseData] = useState({});

  //month variables
  const [selectedMonth, setSelectedMonth] = useState("Select Month");
  const monthChoices = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  //year variables
  const [selectedYear, setSelectedYear] = useState("Select Year");
  const currentYear = new Date().getFullYear();
  const yearChoices = Array.from({ length: 21 }, (_, i) => currentYear - i);

  // Handle house selection from modal
  const handleHouseSelection = (houseData) => {
    setSelectedHouseData(houseData);
    setShowHouseSelectionModal(false);
    setShowPaymentModal(true);
  };

  // Handle make payment button click
  const handleMakePaymentClick = () => {
    setShowHouseSelectionModal(true);
  };

  // Close payment modal
  const closePaymentModal = () => {
    setShowPaymentModal(false);
    setSelectedHouseData({});
  };

  const applyFilters = () => {
    // Convert selected month to a number
    const monthIndex = monthChoices.indexOf(selectedMonth);
    const monthNumber = monthIndex !== -1 ? monthIndex + 1 : null;
    if (!monthNumber) {
      console.error("Invalid month selected");
      return;
    }

    // Fetch filtered data based on the selected property and date range
    const propertyId = properties.find(
      (property) => property.name === selectedApartment,
    )?._id;

    if (propertyId) {
      setSelectedApartmentId(propertyId);
      dispatch(
        fetchPayments({
          propertyId,
          month: monthNumber,
          year: selectedYear,
        }),
      ).then((res) => {
        console.log("res", res);
      });

      dispatch(
        listInvoicesUnpaid({
          property_id: propertyId,
          selectedMonth: monthNumber,
          selectedYear,
        }),
      ).then((res) => {
        console.log("unpaid invoices", res);
      });
    }

    // Reset table view to default if needed
    setTableToView("transactions");
  };

  return (
    <div className="mid-section-payments-pc-admin">
      <div className="top-section-payments-pc">
        <div className="title">
          Your Reports
          <div className="description">Invoice and payment information</div>
          {/* moved Make Payment button into the title area */}
        </div>
        <div className="make-payment-button">
          {/* <div className="box-title">Quick Action</div> */}
          <button onClick={handleMakePaymentClick} className="make-payment-btn">
            Make Payment
          </button>
        </div>
      </div>

      <div className="horizontal-line"></div>
      <div className="filters-container">
        <div className="drop-down">
          <div className="box-title">Apartment Choice</div>
          <div className="select">
            <DropdownSelect
              choices={apartmentChoices}
              defaultChoice={selectedApartment}
              onSelect={setSelectedApartment}
            />
          </div>
        </div>
        <div className="box">
          <div className="box-title">Month</div>
          <div className="select">
            <DropdownSelect
              choices={monthChoices}
              defaultChoice={selectedMonth}
              onSelect={setSelectedMonth}
              backgroundColor={"transparent"}
              textColor={"#192a3a"}
              border={"1px solid #ccc"}
            />
          </div>
        </div>
        <div className="box">
          <div className="box-title">Year</div>
          <div className="select">
            <DropdownSelect
              choices={yearChoices}
              defaultChoice={selectedYear}
              onSelect={setSelectedYear}
              backgroundColor={"transparent"}
              textColor={"#192a3a"}
              border={"1px solid #ccc"}
            />
          </div>
        </div>
        <div className="apply-filters-button">
          <div className="box-title">Confirm </div>
          <button onClick={applyFilters}>Apply Filters</button>
        </div>

        {/* removed the previous .make-payment-button from here */}
      </div>
      <div className="horizontal-line"></div>

      <div className="cards-container">
        <InformationCardPc
          Title={"Invoices Paid"}
          percentage={cardPercentages.invoicesPaid}
          setTableToView={setTableToView}
          valueToSet={"transactions"}
        />
        <InformationCardPc
          Title={"Invoices Pending"}
          percentage={cardPercentages.invoicesPending}
          setTableToView={setTableToView}
          valueToSet={"invoices"}
        />
        <InformationCardPc
          Title={"Approved Payments"}
          percentage={cardPercentages.approvedPayments}
          setTableToView={setTableToView}
          valueToSet={"approved"}
        />
        <InformationCardPc
          Title={"Awaiting Aproval"}
          percentage={cardPercentages.awaitingApproval}
          setTableToView={setTableToView}
          valueToSet={"awaiting"}
        />
      </div>
      <div className="transactions-and-progress">
        <div className="transactions-container">
          <div className="title">
            {tableToView === "transactions" && (
              <div className="description">Latest Payments Made</div>
            )}
            {tableToView === "invoices" && (
              <div className="description">Pending Invoices</div>
            )}
            {tableToView === "approved" && (
              <div className="description">Approved Payments</div>
            )}
            {tableToView === "awaiting" && (
              <div className="description">Payments awaiting approval</div>
            )}
          </div>

          <div className="transaction-history-table">
            {tableToView === "transactions" && (
              <TransactionsTable
                selectedApartmentId={selectedApartmentId}
                selectedMonth={selectedMonth}
                selectedYear={selectedYear}
                approved={true}
                monthChoices={monthChoices}
              />
            )}
            {tableToView === "invoices" && (
              <InvoicePendingTable selectedApartmentId={selectedApartmentId} />
            )}
            {tableToView === "approved" && (
              <TransactionsTable
                selectedApartmentId={selectedApartmentId}
                selectedMonth={selectedMonth}
                selectedYear={selectedYear}
                approved={true}
                monthChoices={monthChoices}
              />
            )}
            {tableToView === "awaiting" && (
              <TransactionsTable
                awaitingApproval={true}
                selectedApartmentId={selectedApartmentId}
                selectedMonth={selectedMonth}
                selectedYear={selectedYear}
                monthChoices={monthChoices}
              />
            )}
          </div>
        </div>
      </div>

      {/* House Selection Modal */}
      <HouseSelectionModal
        isOpen={showHouseSelectionModal}
        onClose={() => setShowHouseSelectionModal(false)}
        onSelectHouse={handleHouseSelection}
      />

      {/* Payment Modal */}
      <PaymentModal
        isOpen={showPaymentModal}
        closeModal={closePaymentModal}
        selectedApartmentId={selectedHouseData.propertyId}
        defaultValues={{
          house_id: selectedHouseData.house_id,
          house_no: selectedHouseData.house_no,
          rent: selectedHouseData.rent?.toString() || "0",
          water: "0",
          arrears: "0",
          serviceCharge: "0",
          unpaidDeposit: "0",
          garbage: "0",
          paymentMethod: "PAYBILL",
        }}
        fieldsToShow={[
          "rent",
          "water",
          "arrears",
          "serviceCharge",
          "unpaidDeposit",
          "garbage",
        ]}
      />
    </div>
  );
};

export default MidSectionPaymentsPc;
